import React from "react";
import styles from "./styles/Home.module.css";
import logo_cloud from '../imgs/logo_cloud.png';

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      json: null
    };
  }

  componentDidMount() {
    fetch("assets/cloud.json")
      .then(res => res.json())
      .then(json => this.setState({ json }));
  }

  render() {
    const { json } = this.state;
    return (
      <div className={styles.bg}>
        <div className={styles.logo}>
          <img src={logo_cloud} className={styles.img} />
          <div className={styles.logoText}>大豪云新版APP公测版</div>
        </div>
        <ul className={styles.linkBtns}>
          <a href={`assets/${json && json.name1}.apk`}>
            <li className={styles.linkBtn}>
              <span className={styles.btnImgAndroid} />
              <span className={styles.linkDownload}>安卓四合一版（v2.9.6）</span>
            </li>
          </a>
          <div className={styles.gap} />
          <a href={`assets/qianhu.apk`}>
            <li className={styles.linkBtn}>
              <span className={styles.btnImgAndroid} />
              <span className={styles.linkDownload}>QH扫码枪专用</span>
            </li>
          </a>
          <div className={styles.gap} />
          <a href={`assets/${json && json.name}.apk`}>
            <li className={styles.linkBtn}>
              <span className={styles.btnImgAndroid} />
              <span className={styles.linkDownload}>安卓公测版</span>
            </li>
          </a>
          <div className={styles.gap} />
          <a href={`assets/${json && json.name2}.apk`}>
            <li className={styles.linkBtn}>
              <span className={styles.btnImgAndroid} />
              <span className={styles.linkDownload}>袜机采购定制平台</span>
            </li>
          </a>
          <div className={styles.gap} />
          <a href={`assets/${json && json.name3}.apk`}>
            <li className={styles.linkBtn}>
              <span className={styles.btnImgAndroid} />
              <span className={styles.linkDownload}>袜机采购定制平台app</span>
            </li>
          </a>
          {/* <div className={styles.gap} />
          <a href={json && json.link_ios}>
            <li className={styles.linkBtn}>
              <span className={styles.btnImgIos} />
              <span className={styles.linkDownload}>IOS公测版</span>
            </li>
          </a> */}
          <div className={styles.gap} />
          <a href={`assets/kanban_iot_dahaoyun_cn.apk`}>
            <li className={styles.linkBtn}>
              <span className={styles.btnImgAndroid} />
              <span className={styles.linkDownload}>看板App（cn）</span>
            </li>
          </a>
          <div className={styles.gap} />
          <a href={`assets/kanban_v2_iot_dahaoyun_cn.apk`}>
            <li className={styles.linkBtn}>
              <span className={styles.btnImgAndroid} />
              <span className={styles.linkDownload}>看板App（cn-v2）</span>
            </li>
          </a>
          <div className={styles.gap} />
          <a href={`assets/kanban_iot_dahaoyun_net.apk`}>
            <li className={styles.linkBtn}>
              <span className={styles.btnImgAndroid} />
              <span className={styles.linkDownload}>看板App（net）</span>
            </li>
          </a>
          <div className={styles.gap} />
          <a href={`assets/dahaoyun-sx.apk`}>
            <li className={styles.linkBtn}>
              <span className={styles.btnImgAndroid} />
              <span className={styles.linkDownload}>纺纱云-安卓</span>
            </li>
          </a>
          <div className={styles.gap} />
          <a href={`assets/dahaoyun-weighing.apk`}>
            <li className={styles.linkBtn}>
              <span className={styles.btnImgAndroid} />
              <span className={styles.linkDownload}>打样称重-安卓</span>
            </li>
          </a>
        </ul>
        <div className={styles.net}>新版本抢先体验</div>
      </div>
    );
  }
}
